const URL_API = process.env.URL_API;
import request from '../utils/request';
import { getCookie, removeCookie, setCookie } from '../utils/cookie';
import router from 'next/router'

export async function getCategories() {
    let url = '/supplier-categories';

    return request(url, {
        method: 'GET',
    });

}

export async function getCategoriesWithSearch(id: any) {

    let url = '/supplier-categories?q=' + id;

    return request(url, {
        method: 'GET',
    });

}

export async function getCategory(id: any) {
    return request(`/supplier-categories/${id}`, {
        method: 'GET',
    });
}

export async function sendQuoteRequestApi(infoData: any[]) {

    const url = `${URL_API}/request-a-quote`;
    const data = infoData[0];

    return request(url, {
        method: 'POST',
        data,
    });

}
